export default "__VITE_ASSET__Cgvsgvjr__"